<style scoped lang="scss">
    .bottom {
        justify-content: flex-end;
    }

    textarea {
        border: 0px none;
        outline: none;
        width: 100%;
        resize: none;
    }
</style>
<template>
    <div class="send bg_fff pl15 pr15 pt15 pb15">
        <textarea placeholder="请说点什么吧" v-model="content" @keyup.enter="handler"></textarea>
        <div class="flex bottom">
            <p class="app_btn_main_mini pointer" @click="handler">发送</p>
        </div>
    </div>
</template>

<script>
  import {isEmpty} from "../../lib/utils";

  export default {
    name: "send-msg-box-simple",
    data() {
      return {
        content: ''
      }
    },
    methods: {
      clear() {
        this.content = "";
      },
      handler() {
        const {content} = this;
        if (isEmpty(content)) return this.$message.error('消息不能为空');
        this.$emit('send', content);
      }
    },
  }
</script>
